import { useState } from 'react';
import { toggleFilterActive } from '../services/data-service';
import './filter-input.scss';

const FilterInput = ({ data }) => {

    const [active, setActive] = useState(data.active);

    const onChange = (event) => {
        setActive(event.target.checked);
        toggleFilterActive(data.id);
    }

    return(
        <label 
            key={'input-' + data.id}
            className={"data-map-input" + (data.disabled ? ' disabled': '') + (' ' + data.type) + (active ? ' checked' : '')} 
        >
            <input type={data.type} name={data.name} checked={active} onChange={(e) => onChange(e)} disabled={data.disabled} />
            {data.label}
        </label>
    );
};

export default FilterInput;